// comparison-pricing.js
// Renders the pricing comparison cards for all competitors

(function() {
  'use strict';
  
  const pricingData = {
    shingleback: {
      competitorModel: 'Sport 5',
      competitorPrice: '$2,100',
      competitorFeatures: [
        '✓ 10-year warranty',
        '✓ Made in Victoria, Australia',
        '✓ Duragal steel construction',
        '✓ Marine-grade bungee cords',
        '✓ Third-party engineering cert',
        '✓ Optional swing arm available'
      ]
    },
    velocirax: {
      competitorModel: 'MAX 4',
      competitorPrice: '$799+',
      competitorFeatures: [
        '✓ Hydraulic self-lowering system',
        '✓ 100 lb per basket capacity',
        '✓ Roll-in/roll-out loading',
        '✓ Garage wall mounting kit',
        '✓ Wide bike compatibility',
        '✓ SkiRAX conversion available'
      ]
    },
    thule: {
      competitorModel: 'T2 Pro XTR 4',
      competitorPrice: '$1,450+',
      competitorFeatures: [
        '✓ Limited lifetime warranty',
        '✓ Premium Swedish brand',
        '✓ Advanced anti-sway system',
        '✓ Tool-free installation',
        '✓ Tilting mechanism',
        '✓ Global brand reputation'
      ]
    },
    atlantis: {
      competitorModel: '4-Bike Model',
      competitorPrice: 'Contact for Quote',
      competitorFeatures: [
        '✓ Australian manufactured',
        '✓ Various configurations',
        '✓ Standard bike capacity',
        '✓ Hitch mount system',
        '✓ Bike securing straps',
        '✓ Local customer support'
      ]
    }
  };
  
  function renderPricing() {
    // Get the page handle from the URL
    const pageHandle = window.location.pathname.split('/').pop();
    const competitor = pageHandle.split('-vs-')[1] || '';
    const data = pricingData[competitor];
    
    // If no data found for this competitor, exit gracefully
    if (!data) {
      console.log('No pricing data found for competitor:', competitor);
      return;
    }
    
    // Find the container element
    const container = document.getElementById('pricing-cards-content');
    if (!container) {
      console.log('Pricing container not found');
      return;
    }
    
    // Capitalize competitor name for display
    const competitorName = competitor.charAt(0).toUpperCase() + competitor.slice(1);
    
    // Render the pricing cards
    container.innerHTML = 
      '<div class="pricing-card featured">' +
        '<h3>JB Racks 4-Bike</h3>' +
        '<div class="price">$800*</div>' +
        '<p style="font-size: 0.9em; color: #666;">*Limited time sale price (RRP $1,199)</p>' +
        '<ul class="price-features">' +
          '<li>✓ Australian made in South Australia</li>' +
          '<li>✓ Anti-wobble hitch bracket included</li>' +
          '<li>✓ Upgraded thick rubber straps</li>' +
          '<li>✓ Optional slow-fold damper available</li>' +
          '<li>✓ Lightweight at 26kg</li>' +
          '<li>✓ Direct shipping to door (free)</li>' +
        '</ul>' +
        '<a href="/collections/all" class="cta-button" style="margin-top: 20px; display: inline-block;">Shop JB Racks</a>' +
      '</div>' +
      '<div class="pricing-card">' +
        '<h3>' + competitorName + ' ' + data.competitorModel + '</h3>' +
        '<div class="price">' + data.competitorPrice + '</div>' +
        '<ul class="price-features">' +
          data.competitorFeatures.map(function(feature) {
            return '<li>' + feature + '</li>';
          }).join('') +
        '</ul>' +
      '</div>';
  }
  
  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderPricing);
  } else {
    renderPricing();
  }
})();